import { domainUrl } from '../constants';

export const API_COLLECTIONS = `${domainUrl}collections`;
export const API_COLLECTION = `${domainUrl}collections/{id}`;
export const API_PRODUCTS_OF_COLLECTION = `${domainUrl}collections/{id}/products`;
